import { render, staticRenderFns } from "./Room.vue?vue&type=template&id=1efd71ee&scoped=true"
import script from "./Room.vue?vue&type=script&lang=js"
export * from "./Room.vue?vue&type=script&lang=js"
import style0 from "./Room.vue?vue&type=style&index=0&id=1efd71ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efd71ee",
  null
  
)

export default component.exports